module.exports = __webpack_public_path__ + "static/media/play_store_button.36257ab4.svg";